/**
 * Monotonic sequence counter for the owner's mirror-event emit stream.
 *
 * Shared across `frame` and `mutation` event kinds so ordering is
 * preserved — local React-driven mutations and WS frames interleave
 * correctly at mirrors.
 *
 * Starts at 0; reset to 0 on owner promotion so each owner-session has
 * a fresh sequence. The `ownerEpoch` in every event already fences
 * stale-session events, so per-session monotonicity is sufficient.
 */

let seq = 0;

/** Return the next sequence number (1-indexed per owner-session). */
export function nextOwnerSeq(): number {
  return ++seq;
}

/** Return the current sequence number without incrementing.
 *  Used by the snapshot service to record the highest seq already emitted
 *  at the moment of serialization, so mirrors can discard buffered events
 *  that are already reflected in the snapshot. */
export function peekOwnerSeq(): number {
  return seq;
}

/** Reset the counter to 0 — called on `denker://owner-changed` when this
 *  window is promoted to owner so the new session starts from 1. */
export function resetOwnerSeq(): void {
  seq = 0;
}
